import {
  required,
  numeric,
  requiredIf,
  email,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'
export default {
  tipoIniciador: {
    required
  },
  calleTramite: {
    required
  },
  tipoTramite: {
    required
  },
  clasificacion: {
    required
  },
  alturaTramite: {
    required,
    numeric
  },
  oficinaAreaInterna: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Area Interna'
    })
  },
  // Persona
  tipoDocumento: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona'
    })
  },
  numero: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona'
    }),
    numeric: numeric,
    minLength: minLength(7),
    maxLength: maxLength(8)
  },
  nombre: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona'
    })
  },
  apellido: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona'
    })
  },
  emailIniciador: {
    email
  },
  direccionIniciador: {
    formattedAddress: {
      required: requiredIf(function () {
        return this.form.tipoIniciador === 'Persona'
      })
    }
  },
  numeroCuenta: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona'
    })
  },
  tipoSociedad: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona Jurídica'
    })
  },
  razonSocial: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona Jurídica'
    })
  },
  cuit: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona Jurídica'
    })
  },
  domiciolioComercio: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona Jurídica'
    })
  },
  emailComercio: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona Jurídica'
    }),
    email
  },
  numeroPadron: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona Jurídica'
    })
  },
  numeroPadronSeleccionado: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Persona Jurídica'
    })
  },
  notaAreaInterna: {
    required: requiredIf(function () {
      return this.form.tipoIniciador === 'Area Interna'
    })
  }
}
